type NavigateOptions = {
  url: string;
  inputValue?: string;
  router?: { push: (path: string) => void };
};

export const ADVISOR_URL = 'https://local.thrivent.com/';

export const useNavigateToAdvisorPage = () => {
  const navigate = ({
    url = ADVISOR_URL,
    inputValue = '',
    router,
  }: NavigateOptions) => {
    const query = inputValue ? `?qp=${inputValue}` : '';
    const fullUrl = `${url}${query}`;

    if (router && typeof router.push === 'function') {
      router.push(fullUrl);
    } else {
      // fallback for non-Next.js or pages using plain JS routing
      if (typeof window !== 'undefined') {
        window.location.href = fullUrl;
      }
    }
  };

  return navigate;
};
